import {Disposable, Environment} from 'relay-runtime';
import {commitMutation, graphql} from 'react-relay';
import Util from '../../forecast-app/shared/util/util';
import {trackEvent} from '../../tracking/amplitude/TrackingV2';
import {CreateBillToInput} from './__generated__/CreateBillToMutation.graphql';
import {omit} from 'lodash';
import {DeclarativeMutationConfig} from 'relay-runtime/lib/mutations/RelayDeclarativeMutationConfig';

const mutation = graphql`
	mutation DeleteBillToMutation($input: DeleteBillToInput!) {
		deleteBillTo(input: $input) {
			deletedBillToId
		}
	}
`;

function getConfigs(input): DeclarativeMutationConfig[] {
	return [
		{
			type: 'RANGE_DELETE',
			parentID: input.billFromId,
			connectionKeys: [
				{
					key: 'BillFrom_billTos',
				},
			],
			pathToConnection: ['billFroms', 'billTos'],
			deletedIDFieldName: 'deletedBillToId',
		},
	];
}

function getOptimisticResponse(input) {
	return {
		deleteBillTo: {
			deletedBillToId: input.billToId,
		},
	};
}
function commit(
	environment: Environment,
	input: CreateBillToInput,
	onSuccess?: (response) => void,
	onError?: (error: Error) => void
): Disposable {
	trackEvent('Bill To', 'Deleted', input);

	const cleanedInput = omit(input, ['billFromId']);

	const variables = {input: {csrfToken: Util.getCsrfValue(), socketClientId: Util.getClientId(), ...cleanedInput}};

	return commitMutation(environment, {
		mutation,
		variables,
		configs: getConfigs(input),
		optimisticResponse: getOptimisticResponse(input),
		onCompleted: onSuccess,
		onError: onError,
	});
}

export default {commit};
